import { Link } from "react-router-dom";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import PageWrapper from "components/layout/PageWrapper";
import "style.css";

type CompetitionEntry = {
  type: "competition";
  name: string;
  years: string;
  image: string;
  route: string;
};

type GapEntry = {
  type: "gap";
  years: string;
  reason: string;
};

type FleetEntry = CompetitionEntry | GapEntry;

// To add a new year: append an entry to this array (newest first).
// After a break, add a gap entry first, then the competition entry below it.
const entries: FleetEntry[] = [
  {
    type: "competition",
    name: "Tiger Fish",
    years: "2025–2026",
    image: "/images/TigerFishPhotos/TapewormModel.png",
    route: "/pastyear2526",
  },
  { type: "gap", years: "2024–2025", reason: "Did not attend competition" },
  {
    type: "competition",
    name: "Jelly 2",
    years: "2023–2024",
    image: "/images/jelly2Photos/Iso.png",
    route: "/pastyear2324",
  },
  { type: "gap", years: "2022–2023", reason: "Did not attend competition" },
  {
    type: "competition",
    name: "Jelly",
    years: "2021–2022",
    image: "/images/jellyPhotos/Jelly_IsoV2.png",
    route: "/pastyear2122",
  },
  {
    type: "competition",
    name: "Jelly",
    years: "2020–2021",
    image: "/images/jellyPhotos/Jelly_IsoV2.png",
    route: "/pastyear2021",
  },
  { type: "gap", years: "2019–2020", reason: "Did not attend competition" },
  {
    type: "competition",
    name: "Subby",
    years: "2018–2019",
    image: "/images/viewPhotos/isoView.png",
    route: "/pastyear1819",
  },
];

const SurfIcon = () => (
  <img
    src="/images/logos/surfLogoWhite.png"
    alt=""
    style={{
      width: "100%",
      height: "100%",
      objectFit: "contain",
      padding: "6px",
    }}
  />
);

const Fleet = () => {
  return (
    <div
      style={{ backgroundColor: "var(--color-bg-dark)", minHeight: "100vh" }}
    >
      <PageWrapper>
        <h1 className="fleet-heading">The Fleet</h1>
      </PageWrapper>
      <VerticalTimeline lineColor="var(--color-footer-border)">
        {entries.map((entry, i) =>
          entry.type === "competition" ? (
            <VerticalTimelineElement
              key={i}
              date={entry.years}
              iconStyle={{
                background: "var(--color-primary)",
                boxShadow: "none",
              }}
              icon={<SurfIcon />}
              contentStyle={{
                background: "var(--color-bg-darker)",
                border: "1px solid var(--color-footer-border)",
                boxShadow: "none",
                padding: "0",
                overflow: "hidden",
              }}
              contentArrowStyle={{
                borderRight: "7px solid var(--color-footer-border)",
              }}
            >
              <Link to={entry.route} className="fleet-card">
                <img
                  src={entry.image}
                  alt={`${entry.name} submarine`}
                  className="fleet-card-img"
                  loading="lazy"
                />
                <div className="fleet-card-body">
                  <span className="fleet-card-name">{entry.name}</span>
                  <span className="fleet-card-years">{entry.years}</span>
                  <span className="fleet-card-cta">View →</span>
                </div>
              </Link>
            </VerticalTimelineElement>
          ) : (
            <VerticalTimelineElement
              key={i}
              date={entry.years}
              iconStyle={{
                background: "var(--color-bg-darker)",
                border: "2px solid var(--color-footer-border)",
                boxShadow: "none",
              }}
              contentStyle={{
                background: "transparent",
                border: "1px dashed var(--color-footer-border)",
                boxShadow: "none",
                padding: "0.6rem 1rem",
              }}
              contentArrowStyle={{
                borderRight: "7px solid var(--color-footer-border)",
                opacity: 0.4,
              }}
            >
              <p className="fleet-gap-reason">{entry.reason}</p>
            </VerticalTimelineElement>
          ),
        )}
      </VerticalTimeline>
    </div>
  );
};

export default Fleet;
